import { ReleaseNotesService } from "../../sdServices/release-notes-config/release-notes-service";
import { LocalizationService } from "../../../ShellCommon/localization/localization";
import { ReleaseNotesByAppId } from "../../sdServices/release-notes-config/release-notes-config";
export class SdReleaseNoteRollbackController {
  public ifShowDetails = false;
  public ifShowNotification = true;
  public glyphTypeAriaLabel: string;
  public rollbackFeatures: ReleaseNotesByAppId;
  // @ngInject
  constructor(private sdLocalizationService: LocalizationService, private releaseNotesService: ReleaseNotesService) {
    this.glyphTypeAriaLabel = this.sdLocalizationService.getLocalizedString(
      "ShellCommon",
      "_CONTROLS_ALERT_ERROR_MESSAGE_"
    );
  }

  alertClosed(): void {
    this.ifShowNotification = false;
    this.releaseNotesService.saveRollbackViewedStatus(this.rollbackFeatures);
  }

  showDetail(): void {
    this.ifShowDetails = true;
  }

  hideDetail(): void {
    this.ifShowDetails = false;
  }
}
export const sdReleaseNoteRollback: ng.IComponentOptions = {
  controller: SdReleaseNoteRollbackController,
  templateUrl: "../ServiceDesk/releaseNotes/rollback/sd-release-note-rollback.html",
  bindings: {
    rollbackFeatures: "<"
  }
};
